import React from 'react';
import { Card, Statistic, List, Tag, Alert, Empty } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import paths from 'assets/routes/paths';

function HallazgosCriticosTile({ data, loading }) {
  if (loading) return <Card title="Hallazgos críticos" loading />;
  if (!data) {
    return (
      <Card title="Hallazgos críticos">
        <Empty description="Sin datos" />
      </Card>
    );
  }

  return (
    <Card title="Hallazgos críticos abiertos (ALTA + CRÍTICA)">
      <Statistic
        value={data.total}
        prefix={<WarningOutlined style={{ color: '#f5222d' }} />}
        valueStyle={{ fontSize: '2rem', color: data.total > 0 ? '#f5222d' : '#52c41a' }}
      />
      {data.aging_30d > 0 && (
        <Alert
          type="error"
          showIcon
          message={`${data.aging_30d} con más de 30 días sin resolver`}
          style={{ marginTop: 12 }}
        />
      )}
      {data.top_clientes && data.top_clientes.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <div style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 8 }}>
            Top clientes:
          </div>
          <List
            size="small"
            dataSource={data.top_clientes}
            renderItem={(c) => (
              <List.Item
                style={{ padding: '6px 0', display: 'flex', justifyContent: 'space-between' }}
              >
                <Link to={`${paths.admin.clientes.detail(c.cliente_id)}?tab=hallazgos`}>
                  {c.cliente}
                </Link>
                <Tag color="red">{c.count}</Tag>
              </List.Item>
            )}
          />
        </div>
      )}
    </Card>
  );
}

export default HallazgosCriticosTile;
